function bytesToHex(bytes: Uint8Array): string {
  let out = ''
  for (let i = 0; i < bytes.length; i++) {
    out += bytes[i].toString(16).padStart(2, '0')
  }
  return out
}

function getRandomBytes(len: number): Uint8Array {
  const b = new Uint8Array(len)
  const cryptoObj = (globalThis as { crypto?: Crypto }).crypto
  if (cryptoObj?.getRandomValues) {
    cryptoObj.getRandomValues(b)
    return b
  }
  for (let i = 0; i < len; i++) b[i] = Math.floor(Math.random() * 256)
  return b
}

/** UUID v7（时间有序） */
export function uuidv7(nowMs: number = Date.now()): string {
  const t = Number(nowMs)
  const ts = Number.isFinite(t) && t > 0 ? t : Date.now()

  const bytes = new Uint8Array(16)

  bytes[0] = (ts / 2 ** 40) & 0xff
  bytes[1] = (ts / 2 ** 32) & 0xff
  bytes[2] = (ts / 2 ** 24) & 0xff
  bytes[3] = (ts / 2 ** 16) & 0xff
  bytes[4] = (ts / 2 ** 8) & 0xff
  bytes[5] = ts & 0xff

  const rnd = getRandomBytes(10)
  bytes.set(rnd, 6)

  bytes[6] = (bytes[6] & 0x0f) | 0x70
  bytes[8] = (bytes[8] & 0x3f) | 0x80

  const hex = bytesToHex(bytes)
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
}
